import ApiClient from "@common/api/ApiClient";

/**
 * Class representing the authentication functionality for Guardian Authorisation API
 *
 * Note: Compliance components use this API instead of Guardian Mobile API for authorisation
 *
 * Extends the ApiClient to handle API requests
 *
 * @extends ApiClient
 */
class AuthenticationClient extends ApiClient {
  /**
   * Create a AuthenticationClient.
   * Initializes the API client with the "Authentication" route and sets the API URL key.
   */
  constructor() {
    super("Authentication");
    this.setApiUrlKey("auth_api_url");
  }

  SignIn = async (email, password, claims) => {
    return await this.post("SignIn", {
      id: email,
      password,
      claims,
    });
  };

  SwitchTenant = async (operator) => {
    try {
      const response = await this.post("SwitchTenant", { name: `${operator}` });
      return { status: 200, ...response };
    } catch (error) {
      // Axios puts error response here
      if (error.response) {
        return {
          status: error.response.status,
          ...error.response.data
        };
      } else {
        console.log("Network or unknown error", error);
        throw error;
      }
    }
  };

  RefreshToken = async (refreshToken) =>
    await this.post("RefreshToken", { refreshToken });

  GenerateFRSClientSecret = async (siteId) => {
    return await this.post("GenerateFRSClientSecret", { siteId });
  };

  CheckSuspended = async () => {
    const response = await this.axios.request({
      url: `${sessionStorage.getItem("base_url")}/security/setup/config`,
      method: "GET",
    });
    return response.data;
  };
}

const client = new AuthenticationClient();

export default client;
